'use strict';

const jumper = {
  init(overrides = {}) {
    this.duration = overrides.duration || 1000;
    this.offset = overrides.offset || 0;
    this.callback = overrides.callback || undefined;
    this.easing = overrides.easing || function (t, b, c, d) {
      return c * (t /= d) * t + b;
    };
  },
  jump(target) {
    this.jumpStart = window.pageYOffset;
    this.jumpDuration = this.duration;
    this.jumpOffset = this.offset;
    this.jumpCallback = this.callback;
    this.jumpEasing = this.easing;
    this.jumpDistance = target.nodeType === 1 ? this.jumpOffset + Math.round(target.getBoundingClientRect().top) : target;

    requestAnimationFrame((time) => {
      return this.loop(time);
    });
  },
  loop(currentTime) {
    if (!this.timeStart) {
      this.timeStart = currentTime;
    }

    this.timeElapsed = currentTime - this.timeStart;
    this.jumpNext = this.jumpEasing(this.timeElapsed, this.jumpStart, this.jumpDistance, this.jumpDuration);

    window.scrollTo(0, this.jumpNext);

    this.timeElapsed < this.jumpDuration ? requestAnimationFrame((time) => { return this.loop(time); }) : this.end();
  },
  end() {
    window.scrollTo(0, this.jumpStart + this.jumpDistance);
    typeof this.jumpCallback === 'function' && this.jumpCallback.call();
    this.timeStart = false;
  }
};

export default jumper;
